import { processAstropayDeposit, getDepositOnlineBankingBanks, getOnlineBankingProcessors } from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import i18n from '@/utils/i18n';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    currentState: 'PAYMENT_STEP1', // PAYMENT_STEP1 | PAYMENT_STEP2
    depositStatus: {
      loading: false,
      success: false,
      error: false,
      redirect: false,
    },
    bonusClaimed: false,
    banks: [],
    banksLoading: false,
    onlineBankingProcessors: [],
    currentProcessor: {},
    bankObject: null,
    bankAccount: null,
  };
};
const state = getDefaultState();

const getters = {
  getField,
};
const mutations = {
  updateField,
  setBanks(state, banks) {
    state.banks = banks;
  },
  setOnlineBankingProcessors(state, processors) {
    state.onlineBankingProcessors = processors;
  },
  setCurrentProcessor(state, currentProcessor) {
    state.currentProcessor = currentProcessor;
  },
  setDepositStatus(state, row) {
    state.depositStatus = {
      ...state.depositStatus,
      ...row,
    };
  },
  setBanksLoading(state, loading) {
    state.banksLoading = loading;
  },
};

const actions = {
  tryGetAstropayBanks({ commit, state }) {
    commit('setBanksLoading', true);
    getDepositOnlineBankingBanks(state.currentProcessor.code).then(r => {
      if (r.data.IsSuccess) {
        const banks = r.data.Data;
        commit('setBanksLoading', false);
        commit('setBanks', banks);
      }
    });
  },

  tryGetOnlineBankingProcessors({ commit }) {
    getOnlineBankingProcessors().then(r => {
      if (r.data.IsSuccess) {
        const processors = r.data.Data;
        const dd = [];
        processors.map(processor => {
          dd.push({
            code: processor,
            key: processor.toLowerCase(),
          });
        });
        commit('setOnlineBankingProcessors', dd);
      }
    });
  },
  tryDepositAstropay({ commit, dispatch }, { formData }) {
    commit('setDepositStatus', {
      loading: true,
      success: false,
      error: false,
      redirect: false,
    });
    commit('depositStore/setPostDepositLoading', true, { root: true });
    processAstropayDeposit(formData).then(r => {
      commit('depositStore/setPostDepositLoading', false, { root: true });
      if (r.data.IsSuccess && r.data.Data.bank.link) {
        dispatch('player/tryGetBalance', null, { root: true });
        commit('setDepositStatus', {
          error: false,
          success: true,
          redirect: i18n.t('DepositView.OnlineBanking.Redirect'),
        });
        console.log(r.data.Data.bank.link);
        setTimeout(() => {
          document.location.href = r.data.Data.bank.link;
        }, 2000);
      } else {
        commit('setDepositStatus', {
          error: i18n.t('DepositView.OnlineBanking.Error'),
          success: false,
          redirect: false,
        });
      }
      commit('setDepositStatus', { loading: false });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
